import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import React, { useEffect, useState, useRef } from "react";

const MapComponent = ({ latLng, setLatLng, completeInfoOfCurrentLocation }) => {
  const googleMapRef = useRef();

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: ["places"],
  });

  const onGoogleMapLoad = (mapref) => {
    googleMapRef.current = mapref;

    const zoomInButton = document.createElement("div");
    zoomInButton.innerHTML = `<button style="
                                border: none; 
                                color: #4D4D4D; 
                                height: 35px; 
                                cursor: pointer; 
                                font-size: 30px;
                                width: 100%;
                                background: transparent;
                                border-bottom: 1px solid #e5e5e5;
                                display: flex;
                                align-items: center;
                                justify-content: center;">+</button>`;

    zoomInButton.addEventListener("click", () => {
      mapref.setZoom(mapref.getZoom() + 1);
    });

    const zoomOutButton = document.createElement("div");
    zoomOutButton.innerHTML = `<button style="
                                border: none; 
                                color: #4D4D4D; 
                                height: 35px; 
                                cursor: pointer; 
                                font-size: 40px;
                                background: transparent;
                                display: flex;
                                align-items: center;
                                padding-bottom: 10px;
                                width: 100%;
                                justify-content: center;">-</button>`;

    zoomOutButton.addEventListener("click", () => {
      mapref.setZoom(mapref.getZoom() - 1);
    });

    const zoomControlDiv = document.createElement("div");
    zoomControlDiv.style.backgroundColor = "white";
    zoomControlDiv.style.textAlign = "center";
    zoomControlDiv.style.width = "43px";
    zoomControlDiv.style.margin = "20px";
    zoomControlDiv.style.padding = "7px";
    zoomControlDiv.style.height = "83px";
    zoomControlDiv.style.borderRadius = "6px";
    zoomControlDiv.style.overflow = "hidden";
    zoomControlDiv.style.display = "table";

    zoomControlDiv.appendChild(zoomInButton);
    zoomControlDiv.appendChild(zoomOutButton);

    mapref.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
      zoomControlDiv
    );
  };

  const handleMarkerDragEnd = async (e) => {
    const newLat = e.latLng.lat();
    const newLng = e.latLng.lng();
    setLatLng({ lat: newLat, lng: newLng });

    // Reverse geocoding to get full address
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      { location: { lat: newLat, lng: newLng } },
      (results, status) => {
        if (status === "OK" && results.length) {
          completeInfoOfCurrentLocation(results);
        } else {
          console.error("Geocoder failed: ", status);
        }
      }
    );
  };

  if (!latLng) return null;

  return isLoaded ? (
    <div className="map-container">
      <GoogleMap
        center={latLng}
        mapContainerClassName="map-style"
        zoom={10}
        options={{
          minZoom: 4,
          maxZoom: 17,
          zoomControl: false,
          disableDefaultUI: true,
          fullscreenControl: false,
          streetViewControl: false,
        }}
        onLoad={(map) => {
          const styles = {
            hide: [
              {
                featureType: "administrative.land_parcel",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "administrative.neighborhood",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "road",
                elementType: "labels",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "water",
                elementType: "labels.text",
                stylers: [{ visibility: "off" }],
              },
            ],
          };
          map.setOptions({ styles: styles.hide });
          onGoogleMapLoad(map);
        }}
      >
        {latLng && (
          <Marker
            position={latLng}
            draggable={true}
            onDragEnd={handleMarkerDragEnd}
          />
        )}
      </GoogleMap>
    </div>
  ) : null;
};

export default MapComponent;
